<template>
  <div class="box3">
    <pageTitle title="不同需求 不同起点 学后各有收获" titleColor="#ffffff" />
    <div class="content">
      <div class="item">
        <p>零基础大学生</p>
        <p>· 本专业不好找工作，想转行</p>
        <p>· 对数据感兴趣，希望成为数据分析人才</p>
      </div>
      <div class="item">
        <p>数据专员/初级数据分析师</p>
        <p>· 系统提升业务能力，实现跳槽涨薪</p>
        <p>· 增加数据挖掘、机器学习等技术能力</p>
      </div>
      <div class="item">
        <p>0-3年销售/财务/运营等从业者</p>
        <p>· 减少重复劳动，提高工作效率</p>
        <p>· 增强自身竞争力</p>
      </div>
      <div class="item">
        <p>3年以上互联网从业者/业务主管</p>
        <p>· 提高效益，更好的操盘业务</p>
        <p>· 帮助商业决策</p>
      </div>
    </div>
    <img src="../../../assets/coursePage/dataAnalysis/box3/wenzi.png" alt="" />
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import "swiper/dist/css/swiper.css";
export default {
  components: {
    pageTitle,
  },
};
</script>

<style lang="less" scoped>
.box3 {
  padding: 80px 0 88px;
  width: 100%;
  background: url("../../../assets/coursePage/dataAnalysis/box3/bgc.png")
    no-repeat;
  background-size: cover;
  overflow: hidden;
  .content {
    background: url("../../../assets/coursePage/dataAnalysis/box3/content.png")
      no-repeat;
    background-size: cover;
    width: 686px;
    height: 776px;
    background-size: cover;
    margin: 48px auto 0;
    padding-left: 40px;
    box-sizing: border-box;
    overflow: hidden;
    .item {
      p {
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #64666d;
        line-height: 40px;
      }
      p:nth-child(1) {
        font-size: 28px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(86, 71, 213, 0.81);
        line-height: 52px;
        margin-top: 40px;
        margin-bottom: 12px;
      }
    }
  }
  img {
    margin: 40px auto 0;
    display: block;
    object-fit: contain;
    width: 612px;
  }
}
</style>
